<!-- =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div v-if="lang==='es'">
    <vs-button class="mb-4 ml-2" @click="loginAuth0" color="#eb5424"
      >Login with PeopleTree</vs-button
    >
    <vs-button class="mb-4 ml-2" @click="loginAuth0" color="#eb5424"
      >Login with GetBoarded</vs-button
    >
  </div>
  <div v-else>
    <vs-button class="mb-4 ml-2" @click="loginAuth0" color="#eb5424"
      >Iniciar sesión con PeopleTree</vs-button
    >
    <vs-button class="mb-4 ml-2" @click="loginAuth0" color="#eb5424"
           >Iniciar sesión con GetBoarded</vs-button
    >
  </div>
</template>

<script>
import i18n from "@/i18n/i18n";
export default {
  data(){
    return{
      lang:''
    }
  },

  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: i18n.t('notification.user.auth.checkLogin.warning.w1'),
          text:  i18n.t('notification.user.auth.checkLogin.warning.w2'),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }
      return true;
    },
    registerAuth0 () {
      if (!this.checkLogin()) return;
      this.$auth.login({ target: this.$route.query.to });
    }
  },
  created(){
    this.lang = this.$route.params.lang;
  }
};
</script>
